import { Injectable } from '@angular/core';
import { ProjectProfile } from '../models/projects.model';
import { AccessRulesInitService } from './access-rules/services/access-rules-init.service';
import { AccessRulesStateService } from './access-rules/services/access-rules-state.service';
// eslint-disable-next-line import/no-cycle
import { ConfigFeatures, ProjectInfo } from './access-rules/models/access-rules.model';
import { AccessRulesValidationService } from './access-rules/services/access-rules-validation.service';

@Injectable({
  providedIn: 'root',
})
export class AccessRulesService {
  constructor(
    private initService: AccessRulesInitService,
    private stateService: AccessRulesStateService,
    private validationService: AccessRulesValidationService,
  ) {}

  initialzeLogo(): Promise<void> {
    return this.initService.getLogoInitital();
  }

  initializeService(): Promise<void> {
    return this.initService.initialize();
  }

  getProfile() {
    return this.stateService.getProfile();
  }

  getProjectName() {
    return this.stateService.getProjectName();
  }

  getLogoBase64(): string {
    const base64 = this.stateService.getLogoBase64();
    return `data:image/png;base64,${base64}`;
  }

  getCompactLogoBase64(): string {
    const base64 = this.stateService.getCompactLogoBase64();
    return `data:image/png;base64,${base64}`;
  }

  getFavicon() {
    return this.stateService.getFaviconUrl();
  }

  getSupportAbbreviation() {
    return this.stateService.getSupportAbbreviation();
  }

  getFeaturesRules(): ConfigFeatures {
    return this.stateService.getFeatures();
  }

  isProfileMaster() {
    return this.stateService.isProfileMaster();
  }

  getEnvironmentSettings() {
    return this.initService.getEnvironmentSettings();
  }

  getEnvironmentProjectInfo(): ProjectInfo {
    return this.initService.getEnvironmentProjectInfo();
  }

  getAccessRulesValue() {
    return this.validationService.getAccessRulesValue();
  }

  getAccessMenuByFeature() {
    return this.validationService.getAccessMenuByFeature();
  }

  isFeatureEnabled(enableValue: boolean | undefined): boolean {
    return this.validationService.isFeatureEnabled(enableValue);
  }

  getModelByProfile(model: any) {
    if (typeof model !== 'object') {
      return model;
    }

    const profile = this.getProfile();

    // Try to get value for current profile
    if (model[profile]) {
      return model[profile];
    }

    // Fallback to DEFAULT if current profile not found
    if (model[ProjectProfile.DEFAULT]) {
      return model[ProjectProfile.DEFAULT];
    }

    // Final fallback to the original model
    return model;
  }

  isAllowedByProfileRule(rule: any): boolean {
    return this.validationService.isAllowedByProfileRule(rule);
  }

  getMenuItemsConfig() {
    return this.stateService.getFeatures().menuItems;
  }

  getCustomMenuText(menuKey: string, defaultText: string): string {
    const menuConfig = this.getMenuItemsConfig();
    if (!menuConfig?.enable || !menuConfig?.properties) {
      return defaultText;
    }

    const customText = menuConfig.properties[menuKey as keyof typeof menuConfig.properties];
    return customText || defaultText;
  }
}
